const LOCALE_EN_GB = "en-GB"

const getLangAttribute = pathname => {
    let locale = `${LOCALE_EN_GB[0]}${LOCALE_EN_GB[1]}`
    return locale
}

const getUrlLocale = locale => {
    switch (locale) {
        case "uken":
            return "" // "/uken"
        default:
            return ""
    }
}

const getProductUrl = product => {
    switch (product.locale) {
        case "uken":
            return `${getUrlLocale(product.locale)}/products/${product["seo_page_name"]}/`
        default:
            return `/products/${product["seo_page_name"]}/`
    }
}

const getRecipeUrl = recipe => {
    switch (recipe.locale) {
        case "uken":
            return `${getUrlLocale(recipe.locale)}/recipes/${recipe["seo_page_name"]}/`
        default:
            return `/recipes/${recipe["seo_page_name"]}/`
    }
}

const getCFLanguage = locale => {
    switch (locale) {
        case "uken":
            return LOCALE_EN_GB
        default:
            return LOCALE_EN_GB
    }
}

module.exports = { LOCALE_EN_GB, getLangAttribute, getProductUrl, getRecipeUrl, getCFLanguage }
